import { get, writable } from 'svelte/store';
export var Breakpoint;
(function (Breakpoint) {
    /** < md */
    Breakpoint[Breakpoint["MOBILE"] = 768] = "MOBILE";
    /** < lg */
    Breakpoint[Breakpoint["TABLET"] = 1024] = "TABLET";
    /** >= lg */
    Breakpoint[Breakpoint["DESKTOP"] = Infinity] = "DESKTOP";
})(Breakpoint || (Breakpoint = {}));
function createScreenSizeStore() {
    const screenSize = writable();
    const getSize = () => {
        const width = window.innerWidth;
        if (width < Breakpoint.MOBILE) {
            return Breakpoint.MOBILE;
        }
        else if (width < Breakpoint.TABLET) {
            return Breakpoint.TABLET;
        }
        return Breakpoint.DESKTOP;
    };
    if (typeof window !== "undefined") {
        const resizeObserver = new ResizeObserver(() => {
            if (get(screenSize) !== getSize()) {
                screenSize.set(getSize());
            }
        });
        resizeObserver.observe(document.body);
        screenSize.set(getSize());
    }
    return screenSize;
}
export const screenSize = createScreenSizeStore();
